import Calendar from './Calendar';

export default Calendar;


//////////////////
// WEBPACK FOOTER
// ./~/rc-calendar/es/index.js
// module id = 632
// module chunks = 0